import { render, staticRenderFns } from "./Ticimax.vue?vue&type=template&id=58f6a388&scoped=true"
import script from "./Ticimax.vue?vue&type=script&lang=js"
export * from "./Ticimax.vue?vue&type=script&lang=js"
import style0 from "./Ticimax.vue?vue&type=style&index=0&id=58f6a388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f6a388",
  null
  
)

export default component.exports